export const UPDATE_SECONDARY_TABLES = "UPDATE_SECONDARY_TABLES";

export const updateSecondaryTables = (value) => ({
  type: UPDATE_SECONDARY_TABLES,
  value,
});
